// Google Search Console verification tags for each tenant
export const GSC_TAGS = {
  'govani': 'od0XXpj6dyFLYwX4KMtHuMHd4qMg3IWWhQOuCY1FxtE',
};

// Default tag for unknown tenants (optional)
export const DEFAULT_GSC_TAG = '';

// Helper function to get GSC tag for current tenant
export const getCurrentTenantGscTag = () => {
  const hostname = window.location.hostname;
  
  // Handle localhost development
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return process.env.REACT_APP_LOCAL_GSC_TAG || DEFAULT_GSC_TAG;
  }
  
  // Extract subdomain from hostname
  const subdomain = hostname.split('.')[0];
  
  return GSC_TAGS[subdomain] || DEFAULT_GSC_TAG;
};

// Helper function to check if GSC verification is enabled for current tenant
export const isGscVerificationEnabled = () => {
  const tag = getCurrentTenantGscTag();
  return tag && tag !== DEFAULT_GSC_TAG;
}; 